import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import DropdownMenuWrap from '../DropdownMenuWrap';
import { useSelector } from 'react-redux';
import { permissionCodeSelector } from 'src/selector/user';
import { modalMethods } from '../POSModal';

const AuthorizedDropdownMenu = ({
  menuItemPermissionMap = {},
  onClick,
  record = {},
  placement = 'bottomRight',
  items,
  ...other
}) => {
  const { permissionCodes } = useSelector(permissionCodeSelector);

  const handleClick = useCallback(
    ({ domEvent, key }) => {
      domEvent.stopPropagation();
      if (typeof onClick !== 'function') return;

      const permissionSetting = menuItemPermissionMap[key];
      if (permissionSetting) {
        let accessCode;
        let errorMsgId = 'access-declined';
        if ({}.toString.call(permissionSetting) === '[object Object]') {
          accessCode = permissionSetting.accessCode;
          if (permissionSetting.errorMsgId) errorMsgId = permissionSetting.errorMsgId;
        } else {
          accessCode = permissionSetting;
        }

        if (accessCode && !permissionCodes.includes(accessCode)) {
          modalMethods.show({ messageId: errorMsgId });
          return;
        }
      }

      onClick(key, record, domEvent);
    },
    [permissionCodes, record, onClick]
  );

  return (
    <DropdownMenuWrap
      trigger="click"
      btnStyle={{ padding: 0 }}
      placement={placement}
      menu={{ items, onClick: handleClick, getPopupContainer: (triggerNode) => triggerNode.parentNode }}
      {...other}
    />
  );
};

AuthorizedDropdownMenu.propTypes = {
  menuItemPermissionMap: PropTypes.object,
  onClick: PropTypes.func,
  item: PropTypes.object,
};

export default AuthorizedDropdownMenu;
